import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtBookingWhen, fmtCHF, fmtDate, todayZurich } from "@/lib/format";
import { FormDialog, useSubmit } from "./FormDialog";

const addDays = (s, n) => { const d = new Date(`${s}T00:00`); d.setDate(d.getDate() + n); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

export const canInvoiceBooking = (b, can) => b?.total > 0 && !!b.requester_email && can("invoices", "create");

export const ConfirmBookingDialog = ({ booking, onOpenChange, onSaved }) => {
  const { assoc } = useAuth();
  const [invoice, setInvoice] = useState(true);
  const { saving, run } = useSubmit();
  useEffect(() => { if (booking) setInvoice(true); }, [booking]);
  if (!booking) return null;
  const before = assoc?.booking_invoice_days_before ?? 7;
  const due = [addDays(booking.start.slice(0, 10), -before), addDays(todayZurich(), 1)].sort()[1];

  const submit = () =>
    run(async () => {
      const { data } = await api.post(`/bookings/${booking.id}/confirm`, { create_invoice: invoice });
      if (data.invoice_number) {
        const msg = { sent: "inviata per e-mail", not_configured: "creata ma NON inviata: servizio e-mail non configurato", failed: "creata ma invio e-mail non riuscito" }[data.invoice_email_status];
        toast[data.invoice_email_status === "sent" ? "success" : "warning"](`Fattura ${data.invoice_number} (${fmtCHF(data.invoice_total)}, scadenza ${fmtDate(data.invoice_due_date)}) ${msg}`, { duration: 8000 });
      }
      onOpenChange(false);
      onSaved?.();
    }, "Prenotazione confermata");

  return (
    <FormDialog open onOpenChange={onOpenChange} title="Conferma prenotazione" onSubmit={submit} saving={saving} testId="confirm-booking-dialog" submitLabel="Conferma">
      <div className="rounded-lg bg-slate-50 px-4 py-3 text-sm space-y-1">
        <div className="font-semibold text-slate-900">{booking.room_name} · {fmtBookingWhen(booking)}</div>
        <div>{booking.requester_name} · {booking.requester_email}</div>
        <div data-testid="confirm-booking-total" className="font-semibold">Totale {fmtCHF(booking.total)}{booking.cleaning && " (pulizia inclusa)"}</div>
      </div>
      <label className="flex items-start gap-3 text-sm cursor-pointer">
        <Checkbox data-testid="confirm-booking-invoice" checked={invoice} onCheckedChange={(c) => setInvoice(!!c)} />
        <span>Crea e invia la fattura con polizza QR<br /><span data-testid="confirm-booking-due" className="text-slate-500">Scadenza: {fmtDate(due)}</span></span>
      </label>
    </FormDialog>
  );
};
